<template>
  <div id="app">
    <h1>Aloha Apps</h1>
    <h3>Simple, efficient mobile apps.</h3>
    <div class="credit">
      *Icons made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a>
    </div>
    <div class="links">
      <div>
        <router-link to="/privacy">Privacy</router-link>
      </div>
      <div>
        <router-link to="/disclaimer">Disclaimer</router-link>
      </div>
      <div>
        <router-link to="/contact">Contact Us</router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',

}
</script>

<style style="scss">
#app {
  font-family: Avenir-Light, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  /* background: rgb(92,182,143) */
}
.links {
  display: flex;
  justify-content: center;
  justify-content: space-around;
  max-width: 90%;
  margin: 0 auto;
}

.container {
  margin-top: 20px;
}
h3 {
  margin-bottom: 20px !important;
}
.credit {
  margin: 24px;
}
</style>
